import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ecp-tool-bar2',
  templateUrl: './tool-bar2.component.html',
  styleUrls: ['./tool-bar2.component.css']
})
export class ToolBar2Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
